import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const [tab, setTab] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', first_name: '', last_name: '', phone: '', confirm: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleLogin = async (e) => {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      const r = await axios.post('/api/customers/login', { email: form.email, password: form.password });
      login(r.data.token, r.data.customer);
      navigate('/account');
    } catch (e) { setError(e.response?.data?.error || 'Login failed'); }
    setSaving(false);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError('Passwords do not match');
    if (form.password.length < 6) return setError('Password must be at least 6 characters');
    setSaving(true); setError('');
    try {
      const r = await axios.post('/api/customers/register', { email: form.email, password: form.password, first_name: form.first_name, last_name: form.last_name, phone: form.phone });
      login(r.data.token, r.data.customer);
      navigate('/account');
    } catch (e) { setError(e.response?.data?.error || 'Registration failed'); }
    setSaving(false);
  };

  return (
    <div>
      <div className="page-hero"><h1>{tab === 'login' ? 'Sign In' : 'Create Account'}</h1></div>
      <div className="container" style={{ padding: '52px 20px', maxWidth: 480, margin: '0 auto' }}>
        <div style={{ display: 'flex', background: '#f4f4f4', borderRadius: 10, padding: 4, marginBottom: 28 }}>
          {[['login','Sign In'],['register','Create Account']].map(([val, label]) => (
            <button key={val} onClick={() => { setTab(val); setError(''); }} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', fontWeight: 700, fontSize: 14, background: tab === val ? '#fff' : 'transparent', color: tab === val ? '#1a2744' : '#666', boxShadow: tab === val ? '0 1px 4px rgba(0,0,0,0.1)' : 'none', cursor: 'pointer', transition: 'all 0.15s' }}>
              {label}
            </button>
          ))}
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {tab === 'login' ? (
          <form onSubmit={handleLogin}>
            <div className="form-group"><label className="form-label">Email</label><input className="form-control" type="email" value={form.email} onChange={e => set('email', e.target.value)} required autoFocus /></div>
            <div className="form-group"><label className="form-label">Password</label><input className="form-control" type="password" value={form.password} onChange={e => set('password', e.target.value)} required /></div>
            <button type="submit" className="btn btn-navy btn-lg" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={saving}>{saving ? 'Signing in...' : 'Sign In'}</button>
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#666' }}>
              Don't have an account? <button type="button" onClick={() => setTab('register')} style={{ color: '#c9a227', fontWeight: 700, background: 'none', border: 'none', cursor: 'pointer' }}>Create one →</button>
            </p>
          </form>
        ) : (
          <form onSubmit={handleRegister}>
            <div className="grid-2" style={{ gap: 16 }}>
              <div className="form-group"><label className="form-label">First Name *</label><input className="form-control" value={form.first_name} onChange={e => set('first_name', e.target.value)} required autoFocus /></div>
              <div className="form-group"><label className="form-label">Last Name *</label><input className="form-control" value={form.last_name} onChange={e => set('last_name', e.target.value)} required /></div>
            </div>
            <div className="form-group"><label className="form-label">Email *</label><input className="form-control" type="email" value={form.email} onChange={e => set('email', e.target.value)} required /></div>
            <div className="form-group"><label className="form-label">Phone</label><input className="form-control" value={form.phone} onChange={e => set('phone', e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Password *</label><input className="form-control" type="password" value={form.password} onChange={e => set('password', e.target.value)} required /></div>
            <div className="form-group"><label className="form-label">Confirm Password *</label><input className="form-control" type="password" value={form.confirm} onChange={e => set('confirm', e.target.value)} required /></div>
            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} disabled={saving}>{saving ? 'Creating account...' : 'Create Account'}</button>
          </form>
        )}

        <div style={{ textAlign: 'center', marginTop: 24, padding: '16px', background: '#f8f7f2', borderRadius: 10, fontSize: 13, color: '#666' }}>
          Or <Link to="/checkout" style={{ color: '#c9a227', fontWeight: 700 }}>continue as guest →</Link>
        </div>
      </div>
    </div>
  );
}
